// OPS Occult Library comparative visual archive v7 — Alectryomancy source pack.
(()=>{
  const TITLE='alectryomancy';
  const SOURCES=[
    {
      date:'1863',
      period:'Mid-19th century',
      creator:'Louis Le Breton (1818–1866)',
      work:'Illustration for “Alectryomancie ou Alectromancie” in Dictionnaire infernal',
      page:'Dictionnaire infernal, 6th ed., p. 17; Commons file derived from Gallica / BnF scan',
      institution:'Bibliothèque nationale de France / Gallica; reproduction via Wikimedia Commons',
      collection:'Jacques Collin de Plancy, Dictionnaire infernal, 6th edition, Paris, 1863',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Coq_(Dictionnaire_infernal).png?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Coq_(Dictionnaire_infernal).png',
      rights:'Public domain; faithful scan of a public-domain 1863 illustration; Commons Public Domain Mark',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Louis Le Breton, illustration for Alectryomancie, Jacques Collin de Plancy, Dictionnaire infernal, 6th ed., 1863, p. 17. Public-domain scan via Gallica / Wikimedia Commons.',
      medium:'Book illustration / engraving',
      process:'Printed line engraving',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visual:'A compact rooster study printed directly with the Alectryomancy entry; contour, feather texture and dark hatch marks make the bird the visual subject rather than reconstructing the full alphabet-circle apparatus.',
      note:'This is the strongest direct period image currently located for the named practice: it was printed with the Alectryomancy article itself. It depicts the cock rather than the complete letter-and-grain circle, so the catalogue record says exactly that.',
      verifiedOn:'2026-09-13'
    },
    {
      date:'1877',
      period:'Late 19th century; reproducing ancient Roman auspicial equipment',
      creator:'Illustrator for Daremberg and Saglio; individual engraver not identified in the Commons record',
      work:'Cage des poulets servant aux auspices',
      page:'Illustration in Dictionnaire des antiquités grecques et romaines; after a relief associated with the Villa Albani tradition',
      institution:'Historical book illustration; reproduction via Wikimedia Commons',
      collection:'Daremberg and Saglio, Dictionnaire des antiquités grecques et romaines',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Cage_des_poulets_servant_aux_auspices.jpg?width=1200',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Cage_des_poulets_servant_aux_auspices.jpg',
      rights:'Public-domain 1877 engraving; Commons/PICRYL identify the reproduction as public domain',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Cage des poulets servant aux auspices, 1877, Dictionnaire des antiquités grecques et romaines by Daremberg and Saglio. Public-domain reproduction via Wikimedia Commons.',
      medium:'Antiquarian engraving',
      process:'Printed engraving after ancient relief evidence',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visual:'A portable chicken cage is isolated like an archaeological object; two birds peck within a rigid architectural frame, making the equipment of Roman chicken divination legible as material culture.',
      note:'This is comparative context rather than a depiction of the later alphabet-circle method. Roman sacred-chicken auspices are a related bird-divination tradition; keeping that distinction explicit prevents a visually useful source from being mislabelled as the exact Alectryomancy procedure.',
      verifiedOn:'2026-09-13'
    },
    {
      date:'c. 1905',
      period:'Early 20th century; Russian folk divination scene',
      creator:'Konstantin Makovsky (1839–1915)',
      work:'Christmastide Divination (Святочные гадания)',
      page:'Painting; not applicable',
      institution:'Grodno State Museum of the History of Religion',
      collection:'Museum collection; digital reproduction via Wikimedia Commons / Virtual Museums',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Konstantin_Makovsky_-_Christmastide_Divination.jpg?width=1600',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Konstantin_Makovsky_-_Christmastide_Divination.jpg',
      rights:'Public domain artwork; faithful photographic reproduction identified by Wikimedia Commons as free of known copyright restrictions / Public Domain Mark 1.0',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Konstantin Makovsky, Christmastide Divination, c. 1905, oil on canvas, 160 × 232 cm, Grodno State Museum of the History of Religion. Public-domain reproduction via Wikimedia Commons.',
      medium:'Oil painting',
      process:'Oil painting on canvas',
      material:'Oil paint on canvas',
      dimensions:'160 × 232 cm',
      colour:'Colour',
      visual:'A large interior genre painting uses warm-brown timber, low natural light and concentrated colour around the figures and rooster. The bird is shown actively pecking grain while the surrounding women observe the divination, making the practice itself—not merely the animal—the centre of the scene.',
      note:'This is a documented folk form of rooster divination during Svyatki rather than the alphabet-circle method. The painting broadens the archive from printed definitions and archaeological comparison into a historical depiction of the divinatory act itself.',
      verifiedOn:'2026-09-13'
    }
  ];

  const key=(value)=>String(value||'').trim().toLowerCase();
  const nudgeRenderer=()=>{
    const target=document.querySelector('[data-library-reader]');
    if(!target) return;
    const marker=document.createComment('ops-visual-archive-v7-ready');
    target.appendChild(marker);
    marker.remove();
  };
  const install=()=>{
    const pack=window.OPS_OCCULT_EDITORIAL;
    if(!pack||!Array.isArray(pack.entries)) return false;
    const entry=pack.entries.find((item)=>key(item&&item.title)===TITLE);
    if(!entry) return false;
    entry.visualSources=SOURCES.map((source)=>({...source}));
    nudgeRenderer();
    return true;
  };
  if(!install()) document.addEventListener('DOMContentLoaded',install,{once:true});
})();
